import { Injectable, OnInit } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { DataLoaderService } from '../data-loader.service';
import * as CryptoJS from 'crypto-js';
import { TokenEncrption } from '../encryption-File.service';

@Injectable()
export class ImageLoaderService {    
    public imageData;
	public headerOptions:any
	public requestOptions:any
    encryptedToken: any;
    
    constructor(private _http: Http,private dataLoaderService: DataLoaderService,private tokenEncrption:TokenEncrption) {
        this.encryptedToken =   tokenEncrption.getencryptedToken();
        console.log("this.encryptedToken---->",this.encryptedToken);
        
		
        const headerOptions = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization-Token': this.encryptedToken,
        }
         this.requestOptions = {
            headers: new Headers(headerOptions)
        };
	}

    getImageData() {
        //  let url = "http://CGSCLX091045639:8080/configurator/services/vc/configurations/SWTImageData";
        let url = "https://production.gorillas.mercedes-benz.com/prod/veh/configuration/vc/configurations/SWTImageData";
        return this._http.get(url,this.requestOptions)
            .map((response) => {
                let data = response.json();
                if (data) {
                    this.imageData = data
                }
                return (this.imageData);
             },
             (err) => {
                if (err.status === 500) {
				    if (JSON.stringify(err._body).includes('details')) {
				    this.dataLoaderService.errorMessage = err._body;
				    } else if (!JSON.stringify(err._body).includes('details')) {
				    this.dataLoaderService.errorMessage=JSON.parse(err._body);
					if(this.dataLoaderService.errorMessage==""){
                            this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                        }
				    } else {
				    this.dataLoaderService.errorMessage="Configurator Application is Down. Please try later."
				    }
				} else if (err.status === 404) {
				if (JSON.stringify(err._body).includes('details')) {
					this.dataLoaderService.errorMessage = err._body;
					} else if (!JSON.stringify(err._body).includes('details')) {
					 this.dataLoaderService.errorMessage=JSON.parse(err._body);
					 if(this.dataLoaderService.errorMessage==""){
                            this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                        }
					} else {
					 this.dataLoaderService.errorMessage="Configurator Application is Down. Please try later."
					}
				} else {
					if (JSON.stringify(err._body).includes('details')) {
					this.dataLoaderService.errorMessage = err._body;
					} else if (!JSON.stringify(err._body).includes('details')) {
					this.dataLoaderService.errorMessage=JSON.parse(err._body);
					if(this.dataLoaderService.errorMessage==""){
                            this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                        }
					} else {
					 this.dataLoaderService.errorMessage="Configurator Application is Down. Please try later."
					}
				}
                this.dataLoaderService.flagDictionary.loadingFlag=false;
                this.dataLoaderService.flagDictionary.exceptionFlag=true;
            }
            );
	}
}


// WEBPACK FOOTER //
// ./src/app/services/img-urls/img-urls.service.ts